import SurveyCampaignApi from "../../api/Survey/Campaign";

export const getCampaign = async (guid: string, languageId: number) => {
  var campaign = await SurveyCampaignApi.getCampaign(guid, languageId);
  campaign.surveys = campaign.surveys.sort((a, b) => a.rank - b.rank);
  return campaign;
};
